<div style="height: 100%">
  <p-tabView>
    <p-tabPanel header="Current Week">
      <ng-container
        *ngTemplateOutlet="
          metricsTemplate;
          context: {
            label: weekDate,
            range: metricRange.Weekly,
            metrics: metrics[0]
          }
        "
      ></ng-container>
    </p-tabPanel>
    <p-tabPanel header="Current Month">
      <ng-container
        *ngTemplateOutlet="
          metricsTemplate;
          context: {
            label: monthDate,
            range: metricRange.Monthly,
            metrics: metrics[1]
          }
        "
      ></ng-container>
    </p-tabPanel>
    <p-tabPanel header="Custom">
      <ng-container
        *ngTemplateOutlet="
          metricsTemplate;
          context: {
            label: null,
            range: metricRange.Custom,
            metrics: customRangeMetrics
          }
        "
      ></ng-container>
    </p-tabPanel>
  </p-tabView>
</div>

<ng-template #metricsTemplate let-label="label" let-range="range" let-metrics="metrics">
  <div style="display: flex; flex-direction: column; height: 100%">
    <div style="display: flex; padding: 2px 5px 10px 5px">
      <div style="flex-grow: 1">
        <div *ngIf="range === metricRange.Weekly" class="metrics-heading">This Week's Overview</div>
        <div *ngIf="range === metricRange.Monthly" class="metrics-heading">
          This Month's Overview
        </div>
        <div *ngIf="range === metricRange.Custom" class="metrics-heading">Custom Overview</div>

        <div class="metrics-subheading" *ngIf="label">
          <img
            src="/assets/images/gamification/calendar.svg"
            style="vertical-align: middle"
            width="24px"
          />
          <span style="margin-left: 5px; display: inline-block; vertical-align: sub">{{
            label
          }}</span>
        </div>

        <!-- Custom date range selector -->
        <div *ngIf="range === metricRange.Custom" style="margin-left: 3px; margin-top: 20px">
          <mat-form-field>
            <mat-label style="margin-bottom: 5px">Select a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input
                matStartDate
                placeholder="Start date"
                disabled
                [value]="customRangeStart"
                (dateChange)="customRangeStartChange($event)"
                (dateInput)="customRangeStartChange($event)"
              />
              <input
                matEndDate
                placeholder="End date"
                disabled
                [value]="customRangeEnd"
                (dateChange)="customRangeEndChange($event)"
                (dateInput)="customRangeEndChange($event)"
              />
            </mat-date-range-input>
            <!--      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
            <mat-datepicker-toggle matSuffix [for]="picker">
              <mat-icon
                svgIcon="date_check_in"
                class="mat-blue-icon"
                matDatepickerToggleIcon
              ></mat-icon>
            </mat-datepicker-toggle>
            <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
          </mat-form-field>
        </div>
        <!-- End of Custom date range selector -->
      </div>
      <div style="flex-shrink: 1" class="today-date">
        Today: {{ todayDate | datex : 'DD MMM YYYY' }}
      </div>
    </div>

    <div *ngIf="metrics; else noMetrics">
      <div class="metric-box">
        <div class="metric-icon">
          <img src="/assets/images/gamification/earnings-wallet.svg" />
        </div>
        <div class="metric-right">
          <div class="main-metric-header">Total Earnings</div>
          <div class="main-metric-label">
            {{ metrics.totalEarnings | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </div>
        </div>
      </div>

      <div class="submetric-container">
        <ng-container
          *ngTemplateOutlet="
            subMetric;
            context: {
              header: 'Total Jobs',
              icon: 'movements-car',
              value: metrics?.supplierJobMetrics?.jobsCompleted,
              unit: 'jobs'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            subMetric;
            context: {
              header: 'Grabbed jobs',
              icon: 'autodeploy-car',
              value: metrics?.supplierJobMetrics?.jobsAutoDeployment,
              perc: metrics?.supplierJobMetrics?.jobsAutoDeploymentPercent.toFixed(1),
              unit: 'jobs'
            }
          "
        ></ng-container>
      </div>

      <div class="submetric-container">
        <ng-container
          *ngTemplateOutlet="
            subMetric;
            context: {
              header: 'Pick-up within 1 hour',
              icon: 'check-location',
              value: metrics?.supplierJobMetrics?.jobsPickupWithin1hr,
              perc: metrics?.supplierJobMetrics?.jobsPickupWithin1hrPercent.toFixed(1),
              perColor: metrics?.supplierJobMetrics?.jobsPickupWithin1hrColor,
              unit: 'Jobs'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            subMetric;
            context: {
              header: 'Drop-off within 1 hour',
              icon: 'check-location',
              value: metrics?.supplierJobMetrics?.jobsDropoffWithin1hr,
              perc: metrics?.supplierJobMetrics?.jobsDropoffWithin1hrPercent.toFixed(1),
              perColor: metrics?.supplierJobMetrics?.jobsDropoffWithin1hrColor,
              unit: 'Jobs'
            }
          "
        ></ng-container>
      </div>

      <div class="submetric-container">
        <ng-container
          *ngTemplateOutlet="
            subMetric;
            context: {
              header: 'Total Mileage Travelled',
              icon: 'mileage',
              value: metrics.totalMileageTravelled.toLocaleString(),
              unit: 'Miles'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            subMetric;
            context: {
              header: 'Total Time Travelled',
              icon: 'time',
              value: getTimeTravelled(metrics)
            }
          "
        ></ng-container>
      </div>
    </div>

    <ng-template #noMetrics>
      <div style="text-align: center; padding: 20px; font-size: 22px; color: #808080">
        No metric data available
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template
  #subMetric
  let-header="header"
  let-icon="icon"
  let-value="value"
  let-perc="perc"
  let-perColor="perColor"
  let-unit="unit"
>
  <div class="sub-metric">
    <div class="metric-sub-box">
      <div class="metric-icon-small">
        <img [src]="'/assets/images/gamification/' + icon + '.svg'" />
      </div>
      <div class="metric-right">
        <div class="metric-header">{{ header }}</div>
        <div class="metric-label">
          <span [innerHTML]="value"></span>
          <span *ngIf="unit" class="small-caps">
            {{ unit }}
          </span>
          <span
            [ngClass]="perColor"
            style="margin-left: 8px; font-variant: small-caps; font-size: 0.75em"
            *ngIf="perc || perc == 0"
            >({{ perc }}%)</span
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>
